'use client';
import React, { useEffect, useCallback, useState } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import Hooks from '@benzinga/hooks';
import { sendResizeEvent } from '@benzinga/partner-widget';

type Dimension = string | number;

interface Props {
  onResize?: (resizeData: { width?: Dimension; height?: Dimension }) => void;
  widget?: boolean;
  widgetId?: string;
}

export const ResizeDetector: React.FC<React.PropsWithChildren<Props>> = ({ children, onResize, widget, widgetId }) => {
  const { height, ref: wrapper, width } = useResizeDetector();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const dispatch = useCallback(
    (width?: number, height?: number): void => {
      const isValid = typeof width === 'number' && typeof height === 'number' && width > 0 && height > 0;

      if (!isValid) {
        return;
      }

      if (onResize) {
        onResize({ height, width });
      }

      if (widget && widgetId) {
        sendResizeEvent(width, height, widgetId);
      }
    },
    [onResize, widget, widgetId],
  );

  // Dispatch on resize detector updates
  useEffect(() => {
    dispatch(width, height);
  }, [width, height, dispatch]);

  useEffect(() => {
    if (wrapper?.current) {
      setTimeout(() => {
        const width = wrapper.current?.offsetWidth ?? 0;
        const height = wrapper.current?.offsetHeight ?? 0;
        dispatch(width, height);
      }, 50);
    }
  });

  if (!mounted) return null;

  return <div ref={wrapper}>{children}</div>;
};
